import { FieldProps, getIn } from 'formik';
import { useCallback } from 'react';
import { ISearchInputProps, SearchInput } from '@shared/inputs/SearchInput';
import { IOption } from '@shared/interfaces';

export interface ISearchInputFieldProps<T, V = string> extends FieldProps, ISearchInputProps<T, V> {}

export const SearchInputField = <T,V>({
  field,
  form,
  ...props
}: ISearchInputFieldProps<T, V>) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const handleChange = useCallback(
    (value: string, fullValueObj?: IOption<unknown> | null) => {
      field.onChange({
        target: {
          name: field.name,
          value,
        },
      });

      props.onChange?.(value, fullValueObj);
    },
    [field, props],
  );

  return (
    <SearchInput 
      {...field}
      {...props}
      error={touched && !!error}
      helperText={(touched && error) || ''}
      onChange={handleChange}
    />
  );
};